// extracted by mini-css-extract-plugin
export default {"defaultImage":"v6MDZ5"};